import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';
import Modal from 'bcl/components/modal';
import LocationEdit from 'bcl/components/location-edit';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type LocationModel from 'bcl/models/location';

export interface BDLocationSignature {
  // The arguments accepted by the component
  Args: {
    model: LocationModel;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class BDLocationComponent extends Component<BDLocationSignature> {
  @service declare router: RouterService;
  closeModal = () => {
    this.router.transitionTo('auth.basic-data');
  };

  <template>
    {{pageTitle "Ort bearbeiten | Barvera" replace=true}}
    <Modal>
      <LocationEdit @model={{@model}} @closeModal={{this.closeModal}} />
    </Modal>
  </template>
}
